<template>
  <div v-if="language == 'pl'" id="cart">

    <div class="cart-icon" v-on:click="toggleExpand">
      <svg version="1.1" viewBox="0 0 450 469.913">
        <path fill="#FFFFFF" d="M423.522,99.054l-315.53-35.222c-2.97-0.332-5.855-0.221-8.604,0.269L84.673,8.341
            	c-0.284-1.078-0.737-2.064-1.314-2.949C83.127,2.388,80.603,0,77.542,0h-71.7C2.628,0,0,2.628,0,5.841v18.92
            	c0,3.212,2.628,5.841,5.841,5.841h50.962l20.532,77.806c0.28,1.06,0.723,2.033,1.286,2.907l37.758,142.772
            	c0.125,0.473,0.288,0.924,0.434,1.385l-44.932,96.619c-0.971,1.381-1.7,2.938-2.143,4.608l-0.359,0.772
            	c-2.151,4.628-1.613,9.838,0.946,13.869c2.165,5.273,7.356,9.015,13.385,9.015h329.293c7.957,0,14.468-6.51,14.468-14.467v-5.513
            	c0-7.956-6.511-14.467-14.468-14.467H112.743l32.395-69.66c0.876,0,1.758-0.036,2.645-0.114l260.01-22.941
            	c13.607-1.202,24.652-11.507,26.792-24.998l15.042-94.888C452.287,116.535,440.4,100.938,423.522,99.054"/>
        <path fill="#FFFFFF" d="M127.8,397.579c-19.975,0-36.167,16.191-36.167,36.167c0,19.975,16.192,36.167,36.167,36.167
            	s36.167-16.192,36.167-36.167C163.967,413.771,147.775,397.579,127.8,397.579"/>
        <path fill="#FFFFFF" d="M359.09,397.579c-19.975,0-36.168,16.191-36.168,36.167c0,19.975,16.193,36.167,36.168,36.167
            	s36.167-16.192,36.167-36.167C395.257,413.771,379.064,397.579,359.09,397.579"/>
      </svg>
      <div v-show="indicator > 0" class="cart-indicator">{{ indicator }}</div>
    </div>

    <div class="popup" v-show="isExpanded || showPopUp">

      <header class="mint">
        <div class="cart-row">
          <p v-html="cartTitle"></p>
          <div id='cart-popup-close' @click="closePopup()">&#215;</div>
        </div>
      </header>


      <cart-items-list :view-mode="'preview'" v-show="indicator > 0"></cart-items-list>


      <footer class="mint" v-show="indicator > 0">
        <div class="cart-row">
          <a class="btn white checkout-button" :href="cartDetailsLink()" v-translate="'checkout'">Checkout</a>
        </div>
      </footer>

    </div>

  </div>
</template>

<script>
    import store from "./../../store/index"
    import CartItemsList from './CartItemsList';

    export default {
        name: 'Cart',
        components: {CartItemsList},
        data() {
            return {
                isExpanded: false,
                showPopUp: false,
                language: window.env.language
            }
        },
        computed: {
            cartTitle() {
                return this.indicator > 0 ? window.translations['your_cart'] : window.translations['your_cart_is_empty'];
            },
            indicator() {
                return store.getters.indicator;
            }
        },
        created() {

            this.$bus.$on('addToCart', this.addItem);
        },

        methods: {
            cartDetailsLink() {
                return window.env.baseUrl + window.translations['rt_shop_details'];
            },

            addItem(sku) {
                console.log("cart recieved event add to cart: " + sku);
                store.dispatch('addItem', sku);

                this.showPopUp = true;
                setTimeout(() => this.showPopUp = false, 4000);

            },
            // przełącznik panelu
            toggleExpand: function () {
                if (this.showPopUp) {
                    this.showPopUp = !this.showPopUp;
                } else {
                    this.isExpanded = !this.isExpanded;
                    if (this.isExpanded) {
                        $("#overlay").css('display', 'block');
                    } else {
                        $("#overlay").css('display', 'none');
                    }
                }
            },
            closePopup() {
                if (this.showPopUp) {
                    this.showPopUp = !this.showPopUp;
                } else {
                    this.isExpanded = false;
                    $("#overlay").css('display', 'none');
                }
            },
            modalTest() {
                this.$modal.show('dialog', {
                    title: 'Alert!',
                    text: 'You are too awesome',
                    buttons: [
                        {
                            title: 'Deal with it',
                            handler: () => {
                                alert('Woot!')
                            }
                        },
                        {
                            title: '',       // Button title
                            default: true,    // Will be triggered by default if 'Enter' pressed.
                            handler: () => {
                            } // Button click handler
                        },
                        {
                            title: 'Close'
                        }
                    ]
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Cart/Cart.vue